import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Description
 * @param {any} ...inputs
 * @returns {any}
 */

/* 
    后面的会覆盖前面的

      className={cn(
              "flex h-[52px] items-center justify-center",
              isCollapsed ? "h-[52px]" : "px-2"
      )}


      className={cn(
        "mt-6 border-l-2 pl-6 italic [&>*]:text-muted-foreground",
        className
      )}

*/

const mergeFn = extendTailwindMerge({ separator: '_' });

export function cn(...inputs) {
  return mergeFn(clsx(inputs));
}
